export const PROJECT_EXPERTISE_CODE_MASK = "*****-**/***-*******";

export const formatProjectExpertiseCode = (value?: string | null): string => {
  if (!value) {
    return "";
  }

  const literals = new Set([...PROJECT_EXPERTISE_CODE_MASK].filter((char) => char !== "*"));
  const raw = [...value].filter((char) => !literals.has(char)).join("");
  let index = 0;
  let formatted = "";

  for (const slot of PROJECT_EXPERTISE_CODE_MASK) {
    if (index >= raw.length) {
      break;
    }

    if (slot === "*") {
      formatted += raw[index];
      index += 1;
    } else {
      formatted += slot;
    }
  }

  return formatted;
};
